module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.page.sections), function(section) {
    return _c('SectionLayout', {
      key: section.key,
      attrs: {
        "section": section
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d3c1e21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/PageLayout.vue
// module id = 2495
// module chunks = 1